export default __webpack_public_path__ + "alberta-shoppingcart-checkmark.fb7a07b28c9cbb1e7758.svg";